import { Box, Grid, Typography } from '@mui/material';
import _ from 'lodash';
import { DateTime } from 'luxon';
import React from 'react';
import { humanizeDate } from '../../utility/dateUtils';
import {
  contentContainerProps,
  dateCellSx,
  datesHeaderContainerSx,
  datesHeaderGridSx,
  DAY_COUNT,
  employeeHeaderSx,
  eventHeaderSx,
} from './employeesScheduleStyles';

const DatesHeader: React.FC<{ weekStart: DateTime }> = ({ weekStart }) => (
  <>
    <Grid size={1} sx={employeeHeaderSx}>
      <Typography>Employees</Typography>
    </Grid>

    <Grid {...contentContainerProps} sx={datesHeaderContainerSx}>
      <Box sx={eventHeaderSx}>
        <Typography fontWeight={500}>Events</Typography>
      </Box>

      <Box sx={datesHeaderGridSx}>
        {_.map(_.range(DAY_COUNT), (dayDiff) => {
          const date = weekStart.plus({ day: dayDiff });

          return (
            <Box key={dayDiff} sx={dateCellSx}>
              <Typography variant="caption" title={humanizeDate(date.toISO())}>
                {`${date.weekdayShort}, ${date.day}`}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Grid>
  </>
);

export default DatesHeader;
